import { Link } from "react-router-dom";

export default function PolicyShell({
  testId,
  overline,
  title,
  contact,
  lastUpdated,
  children,
}) {
  return (
    <div data-testid={testId} className="bg-[#ffffff]">
      <section className="border-b border-[#000000]/10">
        <div className="max-w-[1100px] mx-auto px-6 md:px-10 py-20">
          <p className="overline">{overline}</p>
          <h1 className="font-serif text-5xl md:text-6xl leading-[0.95] mt-4">
            {title}
          </h1>
          {contact && (
            <p className="mt-6 text-sm tracking-[0.16em] uppercase text-[#000000]/55">
              {contact}
            </p>
          )}
        </div>
      </section>

      <section className="max-w-[900px] mx-auto px-6 md:px-10 py-16 space-y-12 text-[#000000]/80 leading-relaxed">
        {children}
        {lastUpdated && (
          <p className="text-[10px] tracking-[0.22em] uppercase text-[#000000]/45 pt-6 border-t border-[#000000]/10">
            {lastUpdated}
          </p>
        )}
        <p className="text-sm text-[#000000]/55">
          Questions?{" "}
          <Link to="/contact" className="text-[#c9a84c] hover:underline">
            Contact us
          </Link>
          .
        </p>
      </section>
    </div>
  );
}

export const Section = ({ id, title, children }) => (
  <article id={id} className="space-y-4">
    <h2 className="font-serif text-2xl md:text-3xl font-semibold text-[#c9a84c]">
      {title}
    </h2>
    <div className="space-y-4 text-[#000000]/80">{children}</div>
  </article>
);

export const SubHead = ({ children }) => (
  <h3 className="font-serif text-xl font-semibold text-[#c9a84c] pt-2">
    {children}
  </h3>
);

export const Note = ({ children }) => (
  <p className="text-sm text-[#000000]/60 italic border-l-2 border-[#c9a84c]/50 pl-4 py-1">
    {children}
  </p>
);

export const Bullets = ({ items }) => (
  <ul className="space-y-2 pl-2">
    {items.map((it, i) => (
      <li key={i} className="flex gap-3">
        <span className="text-[#c9a84c] shrink-0">◆</span>
        <span>{it}</span>
      </li>
    ))}
  </ul>
);
